export default () => {
  return API_URL
}
